export const exportHeaders = [
    {
        label: "Id",
        key: "id"
    },

    {
        label: "Tier",
        key: "tier"
    },


    {
        label: "Privilege Type",
        key: "privilege_type"
    },

    {
        label: "Privilege Code",
        key: "privilege_code"
    },

    {
        label: "Default",
        key: "default"
    },

    {
        label: "Default Assign",
        key: "default_assign"
    },

    
]